/*
 * @Author: chenlin
 * @Date: 2019-07-22 20:52:11
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-16 16:19:13
 * @Description: 在此添加描述
 */
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from '@/router'
import ConditionSearch from '@/components/conditionSearch'
import ElSelectTree from "el-select-tree";
import myTooltip from '@/components/customTooltips'
import Print from 'vue-print-nb'
import publicInitScanCode from '@/mixins/publicInitScanCode'
import echarts from 'echarts'
import VZPrint from './components/print/index'
import Pagination from '@/components/Pagination'
import DictTag from '@/components/DictTag'
import { btnsPermission } from './utils/btnPermission'
import { customValidate, customSerial, checkRegular } from './utils/validate'
import { parseTime } from '@/utils/ruoyi'
import '@/assets/styles/main.scss'
import '@/utils/directive'
// 加载全局组件
Vue.use(ElSelectTree);
Vue.use(ElementUi)
Vue.mixin(publicInitScanCode)
Vue.use(Print)
Vue.use(VZPrint)
Vue.component('condition-search', ConditionSearch)
Vue.component('dict-tag', DictTag)
Vue.component('pagination', Pagination)
Vue.component('myTooltip', myTooltip)
Vue.prototype.$btnsPermission = btnsPermission
Vue.prototype.$store = store
Vue.prototype.$echarts = echarts
Vue.prototype.customValidate = customValidate
Vue.prototype.customSerial = customSerial
Vue.prototype.checkRegular = checkRegular
Vue.prototype.parseTime = parseTime

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
})


